import { Injectable } from '@angular/core';
import * as countries from 'i18n-iso-countries';

@Injectable()
export class TranslationService {

    // Get translation value
    public getTranslationValue(translations: any, language: string, defaultLanguage: string = null): string {
        let value: string = null;

        // Check if translations object exists and has at least one element
        if (translations?.length > 0) {

            // Check if the element with the given language exists and its value is not null or empty
            if (translations?.find(translation => translation?.languageId === language) &&
                translations?.find(translation => translation?.languageId === language)?.value?.trim() !== '') {
                value = translations?.find(translation => translation?.languageId === language)?.value;

            // Check if the element with the default language exists and its value is not null or empty
            } else if (defaultLanguage && translations?.find(translation => translation?.languageId === defaultLanguage) &&
                translations?.find(translation => translation?.languageId === defaultLanguage)?.value?.trim() !== '') {
                value = translations?.find(translation => translation?.languageId === defaultLanguage)?.value;

            // Check if the any element exists and its value is not null or empty
            } else if (translations?.find(x => x?.value?.trim() !== '')) {
                value = translations?.find(x => x?.value?.trim() !== '')?.value;

            // The object does not contain any values that are not null or empty
            } else {
                value = '-';
            }
        }

        return value;
    }

    // Get translation content
    public getTranslationContent(translations: any, language: string, defaultLanguage: string = null): string {
        let content: string = null;

        // Check if translations object exists and has at least one element
        if (translations?.length > 0) {

            // Check if the element with the given language exists and its content is not null or empty
            if (translations?.find(translation => translation?.languageId === language) &&
                translations?.find(translation => translation?.languageId === language)?.content?.trim() !== '') {
                content = translations?.find(translation => translation?.languageId === language)?.content;

            // Check if the element with the default language exists and its content is not null or empty
            } else if (defaultLanguage && translations?.find(translation => translation?.languageId === defaultLanguage) &&
                translations?.find(translation => translation?.languageId === defaultLanguage)?.content?.trim() !== '') {
                content = translations?.find(translation => translation?.languageId === defaultLanguage)?.content;

            // Check if the first element exists and its content is not null or empty
            } else if (translations?.find(x => x?.content?.trim() !== '')) {
                content = translations?.find(x => x?.content?.trim() !== '')?.content;

            // The object does not contain any contents that are not null or empty
            } else {
                content = '-';
            }
        }

        return content;
    }

    // Get translation value for timeslot
    public getTranslationValueForTimeslot(translations: any, language: string, defaultLanguage: string = null): string {
        let value: string = null;

        // Check if translations object exists and has at least one element
        if (translations?.length > 0) {

            // Check if the element with the given language exists and its value is not null or empty
            if (translations?.find(translation => translation?.languageId === language) &&
                translations?.find(translation => translation?.languageId === language)?.value?.trim() !== '') {
                value = translations?.find(translation => translation?.languageId === language)?.value;

            // Check if the element with the default language exists and its value is not null or empty
            } else if (defaultLanguage && translations?.find(translation => translation?.languageId === defaultLanguage) &&
                translations?.find(translation => translation?.languageId === defaultLanguage)?.value?.trim() !== '') {
                value = translations?.find(translation => translation?.languageId === defaultLanguage)?.value;

            // Check if the any element exists and its value is not null or empty
            } else if (translations?.find(x => x?.value?.trim() !== '')) {
                value = translations?.find(x => x?.value?.trim() !== '')?.value;

            // The object does not contain any values that are not null or empty
            } else {
                value = '';
            }
        }

        return value;
    }

    // Check if the element with the given language exists and its value is not null or empty
    public hasTranslationValue(translations: any, language: string): boolean {
        return this.hasTranslation(translations, language) && translations?.find(translation => translation?.languageId === language)?.value?.trim() !== '';
    }

    // Check if the element with the given language exists and its content is not null or empty
    public hasTranslationContent(translations: any, language: string): boolean {
        return this.hasTranslation(translations, language) && translations?.find(translation => translation?.languageId === language)?.content?.trim() !== '';
    }

    // Check if the element with the given language exists
    public hasTranslation(translations: any, language: string): boolean {
        return translations?.length > 0 && translations?.find(translation => translation?.languageId === language);
    }

    // Get translation name for country language id
    public getCountryTranslation(countryCode: string, language: string): string {
        let value: string = null;

        if (language && countryCode){
            value = countries.getName(countryCode, language);
        }

        return value;
    }
}
